


import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import API from "../services/api";

function SubmittedPage() {
  const [agents, setAgents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [mousePos, setMousePos] = useState({ x: 0, y: 0 });
  const [searchQuery, setSearchQuery] = useState(""); // 🔍 New Search State
  const navigate = useNavigate();

  // 🖱️ Mouse Tracking for Spotlight Effect


  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const res = await API.get("/logs/submitted");

      console.log("🔥 FULL API RESPONSE:", res);
      console.log("🔥 RESPONSE DATA:", res.data);

      setAgents(res.data || []);
    } catch (err) {
      console.error("❌ FETCH ERROR:", err);
      alert("❌ Failed to load submitted data");
    } finally {
      setLoading(false);
    }
  };

  const handleDownload = (pdfPath) => {
  console.log("📄 RECEIVED PATH:", pdfPath);

  if (!pdfPath) {
    console.error("❌ NO PDF PATH FOUND");
    alert("No PDF available");
    return;
  }

  const cleanPath = pdfPath.startsWith("/") ? pdfPath : `/${pdfPath}`;
  const url = `https://vgmconsult.net/api/${cleanPath}`;

  console.log("🌐 FINAL URL:", url);

  window.open(url, "_blank");
};
  // 🔍 Filter Logic
  const filteredAgents = agents.filter((agent) => {
    console.log("👤 AGENT DATA:", agent);
    const term = searchQuery.toLowerCase();
    return (
      agent.name?.toLowerCase().includes(term) ||
      agent.comm_code?.toLowerCase().includes(term) ||
      agent.email?.toLowerCase().includes(term) ||
      agent.mobile?.toLowerCase().includes(term)
    );
  });

  return (
    <div className="submitted-page-wrapper">
      <style>{`
        .submitted-page-wrapper {
          min-height: 100vh;
          background: #020617;
          color: white;
          font-family: 'Plus Jakarta Sans', sans-serif;
          padding: 40px 20px;
          position: relative;
          overflow-x: hidden;
        }

        .spotlight {
          position: fixed;
          top: 0; left: 0; width: 100%; height: 100%;
          background: radial-gradient(circle at ${mousePos.x}px ${mousePos.y}px, rgba(34, 197, 94, 0.05) 0%, transparent 50%);
          z-index: 1; pointer-events: none;
        }

        .container { max-width: 1200px; margin: 0 auto; position: relative; z-index: 2; }

        .header { text-align: center; margin-bottom: 40px; }
        .header h1 {
          font-size: 32px; font-weight: 800; letter-spacing: -1px;
          background: linear-gradient(to right, #fff, #94a3b8);
          -webkit-background-clip: text; -webkit-text-fill-color: transparent;
        }

        /* --- 🔍 SEARCH BOX STYLING --- */
        .search-container {
          margin-bottom: 25px;
          display: flex;
          justify-content: center;
        }

        .search-input {
          width: 100%;
          max-width: 500px;
          background: rgba(255, 255, 255, 0.05);
          border: 1px solid rgba(255, 255, 255, 0.1);
          padding: 14px 20px;
          border-radius: 16px;
          color: white;
          font-size: 15px;
          outline: none;
          transition: 0.3s;
          backdrop-filter: blur(10px);
        }

        .search-input:focus {
          border-color: #22c55e;
          background: rgba(255, 255, 255, 0.08);
          box-shadow: 0 0 20px rgba(34, 197, 94, 0.1);
        }

        /* --- TABLE STYLING --- */
        .glass-card {
          background: rgba(255, 255, 255, 0.02);
          backdrop-filter: blur(20px);
          border: 1px solid rgba(255, 255, 255, 0.08);
          border-radius: 24px;
          padding: 20px;
          overflow-x: auto;
        }

        .logs-table {
          width: 100%;
          border-collapse: separate;
          border-spacing: 0 8px;
          min-width: 800px;
        }

        .logs-table th {
          padding: 15px 20px;
          text-align: left;
          color: #64748b;
          font-size: 13px;
          text-transform: uppercase;
          letter-spacing: 1px;
        }

        .logs-table tr { transition: 0.3s; }

        .logs-table td {
          padding: 16px 20px;
          background: rgba(255, 255, 255, 0.03);
          font-size: 14px;
        }

        .logs-table td:first-child { border-radius: 12px 0 0 12px; }
        .logs-table td:last-child { border-radius: 0 12px 12px 0; }

        .logs-table tr:hover td { background: rgba(255, 255, 255, 0.06); }

        /* --- STATUS BADGES --- */
        .status-badge {
          padding: 6px 12px;
          border-radius: 8px;
          font-size: 11px;
          font-weight: 700;
          text-transform: uppercase;
        }
        .status-badge.submitted { background: rgba(34, 197, 94, 0.1); color: #22c55e; }
        .status-badge.pending { background: rgba(251, 191, 36, 0.1); color: #fbbf24; }

        /* --- BUTTONS --- */
        .download-btn {
          background: #22c55e;
          color: #020617;
          border: none;
          padding: 8px 16px;
          border-radius: 10px;
          font-weight: 700;
          font-size: 12px;
          cursor: pointer;
          transition: 0.2s;
          display: flex;
          align-items: center;
          gap: 6px;
        }
        .download-btn:hover { transform: translateY(-2px); filter: brightness(1.1); }

        .back-btn {
          background: rgba(255,255,255,0.05);
          border: 1px solid rgba(255,255,255,0.1);
          color: #94a3b8;
          padding: 10px 20px;
          width: 15rem;
          border-radius: 12px;
          cursor: pointer;
          font-weight: 600;
          transition: 0.3s;
          margin-bottom: 20px;
        }
        .back-btn:hover { color: white; background: rgba(255,255,255,0.1); }

        .loading-text { text-align: center; color: #64748b; padding: 40px; }
      `}</style>

      <div className="spotlight"></div>

      <div className="container">
        <button className="back-btn" onClick={() => navigate("/dashboard")}>
          ← Dashboard
        </button>

        <header className="header">
          <h1>📁 Submitted Forms</h1>
          <p>Verified database of all approved and signed agent records</p>
        </header>

        {/* 🔍 Search Input Field */}
        <div className="search-container">
          <input
            type="text"
            className="search-input"
            placeholder="Search by name, code, email or contact..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />
        </div>

        {loading ? (
          <div className="loading-text">
            <p>Gathering submitted records...</p>
          </div>
        ) : (
          <div className="glass-card">
            <table className="logs-table">
              <thead>
                <tr>
                  <th>Comm Code</th>
                  <th>Name</th>
                  <th>Email Identity</th>
                  <th>Contact</th>
                  <th>Status</th>
                  <th>Operations</th>
                </tr>
              </thead>

              <tbody>
                {filteredAgents.length === 0 ? (
                  <tr>
                    <td colSpan="6" style={{ textAlign: "center", color: "#475569", padding: "40px" }}>
                      {agents.length === 0
                        ? "🚫 No submitted records found in the system."
                        : "🔍 No records match your search criteria."}
                    </td>
                  </tr>
                ) : (
                  filteredAgents.map((a) => (
                    <tr key={a.id || a._id}>
                      <td style={{ fontWeight: 'bold', color: '#22c55e' }}>{a.comm_code || "N/A"}</td>
                      <td>{a.name}</td>
                      <td style={{ color: '#94a3b8' }}>{a.email}</td>
                      <td>{a.mobile}</td>
                      <td>
                        <span className={`status-badge ${a.status?.toLowerCase()}`}>
                          {a.status}
                        </span>
                      </td>
                      <td>
                        <button
                          className="download-btn"
                          onClick={() => {
    console.log("📄 CLICKED AGENT:", a);
    console.log("📄 PDF PATH:", a.pdf);

    handleDownload(a.pdf);
  }}
>
                          📥 Download PDF
                        </button>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}

export default SubmittedPage;